<template lang="pug">
  div
    el-row
      el-col(:span="20")
        informacoes-pessoa(
          :pessoa="dadosJson.interessado.pessoa",
          :dadosInteressadoRr="null",
          :razaoSocialName="'Razão Social:'"
          :rendaFamiliar="null",
          :compararInformacoesPessoa = "null"
          :isProcessoFisico="false"
        )
    app-divider(label="Endereço")
      informacoes-endereco.margin-top(:endereco="dadosJson.interessado.pessoa.endereco", slot="body")
    listagem-documentos(
    v-if="dadosJson.interessado.documentos"
    :documentos="dadosJson.interessado.documentos",
    :protocoloCadastroOriginal="dadosJson.protocolo"
    ownerDocumento="INTERESSADO"
    :compararDocumentos="null"
    :versaoCadastro = "null"
    )

</template>
<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import InformacoesPessoa from './common/InformacoesPessoa.vue'
import InformacoesEndereco from './common/InformacoesEndereco'
import ListagemDocumentos from '../../components/informacoesCadastro/ListagemDocumentos.vue'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple,
    InformacoesPessoa,
    InformacoesEndereco,
    ListagemDocumentos
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/OutorganteRf.vue